import React, { Dispatch } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { responsiveFontSize } from "@common/components/Typography/style";

type ExpandButtonProps = {
  isExpanded: boolean;
  setIsExpanded: Dispatch<React.SetStateAction<boolean>>;
};

const ExpandButton = ({ isExpanded, setIsExpanded }: ExpandButtonProps) => {
  const { t } = useTranslation();

  const translationKey = isExpanded ? "Minimize" : "Expand";
  const label = t(translationKey);

  const handleClick = () => setIsExpanded((prev) => !prev);

  return (
    <Button
      onClick={handleClick}
      sx={(theme) => responsiveFontSize(theme, "medium")}
    >
      {label}
    </Button>
  );
};

export default ExpandButton;
